import React from 'react';
import { Box, Divider } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Button } from '@uplift/ui-v2';


export type FormFooterProps = {
  onBack?: () => void;
  onNext?: () => void;
  nextDisabled?: boolean;
};


const useFormFooterStyles = makeStyles()(theme => ({
  root: {
    [theme.breakpoints.up('sm')]: {
      marginTop: theme.spacing(4),
    }
  },
  spacer: {
    display: 'block',
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    }
  },
  footer: {
    background: theme.palette.background.paper,
    position: 'fixed',
    width: '100%',
    bottom: 0,
    left: 0,

    [theme.breakpoints.up('sm')]: {
      position: 'relative',
    }
  },
}));


export const FormFooter: React.FC<FormFooterProps> = ({ onBack, onNext, nextDisabled }) => {
  const { classes } = useFormFooterStyles();

  return (
    <Box className={classes.root}>
      <Box p={2} className={classes.spacer}>
        <Button size="large">.</Button>
      </Box>
      <Box className={classes.footer}>
        <Divider />

        <Box p={2} display="flex" justifyContent="space-between">
          {onBack ? <Button onClick={onBack} size="large" variant="text" startIcon={<ArrowBackIcon />}>Back</Button> : <Box />}
          {onNext ? <Button onClick={onNext} size="large" variant="contained" color="secondary" disabled={nextDisabled} endIcon={<ArrowForwardIcon />}>Next</Button> : <Box />}
        </Box>
      </Box>
    </Box>
  );
};
